const SCOPE = 'app/cart/';
export const ActionTypes = {
    CHANGE_EXPIRE_MODAL_IS_VISIBLE: `${SCOPE}CHANGE_EXPIRE_MODAL_IS_VISIBLE`,
    CHANGE_SESSION_ID: `${SCOPE}CHANGE_SESSION_ID`,
    CHANGE_IS_LOADING: `${SCOPE}CHANGE_IS_LOADING`,
    CHANGE_IS_ERROR: `${SCOPE}CHANGE_IS_ERROR`,
    CHANGE_IS_OUTDATED_LOADED: `${SCOPE}CHANGE_IS_OUTDATED_LOADED`,
    CHANGE_IS_LOADED: `${SCOPE}CHANGE_IS_LOADED`,
    CHANGE_ERROR_MESSAGE: `${SCOPE}CHANGE_ERROR_MESSAGE`,
    CHANGE_ITEMS: `${SCOPE}CHANGE_ITEMS`,
    CHANGE_ITEM_PRODUCT_IDS: `${SCOPE}CHANGE_ITEM_PRODUCT_IDS`,
    CHANGE_DATA: `${SCOPE}CHANGE_DATA`,
    CONCAT_ACTIVITIES: `${SCOPE}CONCAT_ACTIVITIES`,
    CLEAR_ACTIVITIES: `${SCOPE}CLEAR_ACTIVITIES`,
    CHANGE_LIFE_TIME: `${SCOPE}CHANGE_LIFE_TIME`,
    CHANGE_ID: `${SCOPE}CHANGE_ID`,
    CHANGE_ITEM_STATE_IS_REMOVING: `${SCOPE}CHANGE_ITEM_STATE_IS_REMOVING`,
    CHANGE_ITEM_STATE_IS_CHANGING: `${SCOPE}CHANGE_ITEM_STATE_IS_CHANGING`,
    CHANGE_ITEMS_STATES: `${SCOPE}CHANGE_ITEMS_STATES`,
    REMOVE_ITEM_BY_ID: `${SCOPE}REMOVE_ITEM_BY_ID`,
    CHANGE_IS_EXTENDING: `${SCOPE}CHANGE_IS_EXTENDING`,
    CHANGE_IS_APPLYING: `${SCOPE}CHANGE_IS_APPLYING`,
    CHANGE_IS_APPLYING_ERROR: `${SCOPE}CHANGE_IS_APPLYING_ERROR`,
    CHANGE_PROMOCODE_VALUE: `${SCOPE}CHANGE_PROMOCODE_VALUE`,
    FETCH: `${SCOPE}FETCH`,
    BACKGROUND_FETCH: `${SCOPE}BACKGROUND_FETCH`,
    UPDATE_SESSION_ID: `${SCOPE}UPDATE_SESSION_ID`,
    EXTEND: `${SCOPE}EXTEND`,
    REMOVE_DISCOUNT: `${SCOPE}REMOVE_DISCOUNT`,
    APPLY_DISCOUNT: `${SCOPE}APPLY_DISCOUNT`,
    ITEM_STATE_IS_REMOVING: `${SCOPE}ITEM_STATE_IS_REMOVING`,
    ITEM_STATE_IS_CHANGING: `${SCOPE}ITEM_STATE_IS_CHANGING`,
    ADD_RESOLVE: `${SCOPE}ADD_RESOLVE`,
    ON_END_FETCH: `${SCOPE}ON_END_FETCH`,
    ON_END_BACKGROUND_FETCH: `${SCOPE}ON_END_BACKGROUND_FETCH`,
    ON_EXPIRING_TIME_LEFT_5M: `${SCOPE}ON_EXPIRING_TIME_LEFT_5M`,
    ON_EXPIRING_TIME_LEFT_1M: `${SCOPE}ON_EXPIRING_TIME_LEFT_1M`,
    ON_EXPIRED: `${SCOPE}ON_EXPIRED`,
};

/**
 * State changing
 */

export const changeExpireModalIsVisible = (isVisible) => ({
    type: ActionTypes.CHANGE_EXPIRE_MODAL_IS_VISIBLE,
    isVisible,
});

export const changeSessionId = (sessionId) => ({
    type: ActionTypes.CHANGE_SESSION_ID,
    sessionId,
});

export const changeIsLoading = (isLoading) => ({
    type: ActionTypes.CHANGE_IS_LOADING,
    isLoading,
});

export const changeIsError = (isError) => ({
    type: ActionTypes.CHANGE_IS_ERROR,
    isError,
});

export const changeIsOutdatedLoaded = (isOutdatedLoaded) => ({
    type: ActionTypes.CHANGE_IS_OUTDATED_LOADED,
    isOutdatedLoaded,
});

export const changeIsLoaded = (isLoaded) => ({
    type: ActionTypes.CHANGE_IS_LOADED,
    isLoaded,
});

export const changeErrorMessage = (errorMessage) => ({
    type: ActionTypes.CHANGE_ERROR_MESSAGE,
    errorMessage,
});

export const changeItems = (items) => ({ type: ActionTypes.CHANGE_ITEMS, items });
export const changeItemProductIds = (itemProductIds) => ({
    type: ActionTypes.CHANGE_ITEM_PRODUCT_IDS,
    itemProductIds,
});

export const changeData = (data) => ({
    type: ActionTypes.CHANGE_DATA,
    data,
});

export const concatActivities = (activities) => ({
    type: ActionTypes.CONCAT_ACTIVITIES,
    activities,
});

export const clearActivities = () => ({
    type: ActionTypes.CLEAR_ACTIVITIES,
});

export const changeLifeTime = ({ lifeTime, timeLeft }) => ({
    type: ActionTypes.CHANGE_LIFE_TIME,
    lifeTime,
    timeLeft,
});

export const changeId = (id) => ({
    type: ActionTypes.CHANGE_ID,
    id,
});

export const changeItemState = {
    isRemoving: (identifier, isRemoving) => ({
        type: ActionTypes.CHANGE_ITEM_STATE_IS_REMOVING,
        identifier,
        isRemoving,
    }),
    isChanging: (identifier, isChanging) => ({
        type: ActionTypes.CHANGE_ITEM_STATE_IS_CHANGING,
        identifier,
        isChanging,
    }),
};

export const changeItemsStates = (itemsStates) => ({
    type: ActionTypes.CHANGE_ITEMS_STATES,
    itemsStates,
});

export const removeItemById = (identifier, productId) => ({
    type: ActionTypes.REMOVE_ITEM_BY_ID,
    identifier,
    productId,
});

export const changeIsExtending = (isExtending) => ({
    type: ActionTypes.CHANGE_IS_EXTENDING,
    isExtending,
});

export const changeIsApplying = (isApplying) => ({
    type: ActionTypes.CHANGE_IS_APPLYING,
    isApplying,
});

export const changeIsApplyingError = (isApplyingError) => ({
    type: ActionTypes.CHANGE_IS_APPLYING_ERROR,
    isApplyingError,
});

export const changePromocodeValue = (value) => ({
    type: ActionTypes.CHANGE_PROMOCODE_VALUE,
    value,
});

/**
 * Triggering and tracking events
 */

export const fetch = (payload) => ({ type: ActionTypes.FETCH, payload });
export const backgroundFetch = (payload) => ({ type: ActionTypes.BACKGROUND_FETCH, payload });
export const updateSessionId = () => ({ type: ActionTypes.UPDATE_SESSION_ID });
export const extend = () => ({ type: ActionTypes.EXTEND });
export const removeDiscount = () => ({ type: ActionTypes.REMOVE_DISCOUNT });
export const applyDiscount = () => ({ type: ActionTypes.APPLY_DISCOUNT });

export const produceItemState = {
    isRemoving: (item, isRemoving) => ({
        type: ActionTypes.ITEM_STATE_IS_REMOVING,
        item,
        isRemoving,
    }),
    isChanging: (item, isChanging) => ({
        type: ActionTypes.ITEM_STATE_IS_CHANGING,
        item,
        isChanging,
    }),
};

export const addResolve = (promise, activity, { destination, category, data }) => ({
    type: ActionTypes.ADD_RESOLVE,
    promise,
    activity,
    optional: { destination, category, data },
});

/**
 * Events
 */

export const onEndFetch = () => ({
    type: ActionTypes.ON_END_FETCH,
});

export const onEndBackgroundFetch = () => ({
    type: ActionTypes.ON_END_BACKGROUND_FETCH,
});

export const onExpiringTimeLeft5m = () => ({
    type: ActionTypes.ON_EXPIRING_TIME_LEFT_5M,
});

export const onExpiringTimeLeft1m = () => ({
    type: ActionTypes.ON_EXPIRING_TIME_LEFT_1M,
});

export const onExpired = () => ({
    type: ActionTypes.ON_EXPIRED,
});
